module.exports = __webpack_public_path__ + "static/PL_TeahouseHibscus-bcdbbb740d517b663a086e98262f29a6.jpg";